var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 75,
    viewBox: "0 0 106 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M73.2888 71.5963C69.5667 70.1229 66.3783 67.7594 63.8504 64.8059C63.8005 64.9743 63.7492 65.1412 63.6926 65.3076C61.1706 72.8599 53.5227 76.7637 46.6102 74.0281C41.5681 72.0322 38.3111 67.0532 37.8964 61.5744C31.6653 66.1522 23.5918 67.5353 16.0029 64.5315C3.38835 59.5387 -3.10677 44.318 1.49629 30.5357C5.89145 17.3762 18.8138 10.2854 30.9533 14.0158C36.7184 2.96236 49.0977 -2.29276 60.3997 2.18021C68.3554 5.32907 73.8757 12.5471 75.7145 20.9058C80.2728 19.6427 85.2105 19.8054 89.9586 21.6843C102.573 26.6771 109.068 41.8978 104.465 55.6801C99.8614 69.4632 85.9033 76.5891 73.2888 71.5963Z",
    fill: "#4EADC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderFeature);
export default __webpack_public_path__ + "static/media/headerFeature.d4b7f467cf2612a906b255a5090a3cba.svg";
export { ForwardRef as ReactComponent };